import { render, staticRenderFns } from "./MidwifeContactDetail.vue?vue&type=template&id=641757e2"
import script from "./MidwifeContactDetail.vue?vue&type=script&lang=js"
export * from "./MidwifeContactDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports